<template v-if="gridViewField && defaultGridView && record && item">
	<div class="gvf">
		<v-menu
			offset-y
			:close-on-content-click="false"
			:open-on-focus="true"
			v-model="menuStatus"
		>
			<template v-slot:activator="{ on, attrs }">
				<v-text-field
					:disabled="isNull"
					:tabindex="tabIndex"
					readonly
					clearable
					v-bind="attrs"
					v-on="on"
					:label="gridViewField.Label"
					v-model="value"
					hide-details="auto"
					@click:clear="onClear"
				>
					<template v-slot:append>
						<v-icon v-if="menuStatus">mdi-menu-up</v-icon>
						<v-icon v-else class="rotate">mdi-menu-up</v-icon>
					</template>
				</v-text-field>
			</template>
			<div style="background-color: white">
				<v-overlay absolute="absolute" :value="loading" :dark="false">
					<v-card max-width="200px">
						<v-card-text class="d-flex justify-center">
							<v-progress-circular
								:size="25"
								indeterminate
								color="primary"
							/>
							<span class="mx-3 text-button">Loading</span>
						</v-card-text>
					</v-card>
				</v-overlay>
				<v-row no-gutters class="mx-5" style="align-items: flex-end">
					<v-text-field
						@click:clear="onSearchClear"
						v-debounce:1000ms="onSearchChanged"
						append-icon="mdi-magnify"
						clearable
						v-model="search"
						hide-details="true"
						label="Search"
					></v-text-field>
					<v-btn
						dense
						small
						color="primary"
						class="ml-5 float-bottom"
						@click="onMore()"
						>More</v-btn
					>
				</v-row>

				<v-list max-height="300" style="overflow-y: scroll">
					<v-list-item-group
						v-model="selected"
						active-class="primary white--text"
						class="field-list"
					>
						<v-list-item
							v-for="(item, index) in linkFieldValues"
							@click.prevent="onSelectItem(item)"
							:key="index"
							:value="item"
						>
							<v-list-item-content>
								<v-list-item-title>
									<span
										v-for="(key, indexKey) in columnsKeys"
										:key="indexKey"
									>
										<span v-if="key != columnKey">{{
											item[key]
										}}</span>
										<span style="font-weight: 700" v-else>{{
											item[key]
										}}</span>
										<span
											v-if="
												indexKey <
												columnsKeys.length - 1
											"
										>
											/
										</span>
									</span>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list-item-group>
				</v-list>
			</div>
			<LinkFieldModal
				v-if="currentGridView && showDialog"
				@close="closeDialog()"
				@rowClicked="onRowClicked"
				:dialog="showDialog"
				:gridView="currentGridView"
				:action="loadAction"
			/>
		</v-menu>
		<v-checkbox
			v-if="isBulkEdit"
			v-model="isNull"
			label="Set field to null"
			class="ma-0"
			hide-details
			@change="onSelectItem()"
		></v-checkbox>
	</div>
</template>
<script>
import LinkFieldModal from '../LinkFieldModal.vue';
import gridViewFieldsUtils from '../../../../utils/gridViewFieldsUtils';
import dataFieldUtils from '../../../../utils/dataFieldUtils';
import { gridViewTypes } from '../../../../enums/gridViewTypes';
import { mapGetters } from 'vuex';
import { GridsGetters } from '../../../../store/getters';
import { GridsPageEditActions } from '../../../../store/actions';
import gridFieldMixin from '../../../../mixins/grids/gridFieldMixin';
export default {
	name: 'LinkField',
	mixins: [gridFieldMixin],
	components: { LinkFieldModal },
	data() {
		return {
			menuStatus: false,
			search: null,
			selected: null,
			showDialog: false,
			linkFieldValues: [],
			loading: false,
			value: null,
			loadAction: GridsPageEditActions.LOAD_LINK_FIELD_VALUES,
		};
	},
	computed: {
		...mapGetters({
			gridViews: [GridsGetters.GET_GRID_VIEWS],
		}),
		dataField() {
			if (!this.gridViewField) return null;
			return this.gridViewField.DataField;
		},
		currentGridViewEntityId() {
			if (!this.dataField) return null;
			return this.dataField.EntityId;
		},
		currentGridView() {
			if (!this.currentGridViewEntityId) return null;
			let entityId = this.currentGridViewEntityId;
			let gv = this.gridViews.find(
				(x) => x.Type === gridViewTypes.Grids && x.EntityId == entityId
			);
			return gv;
		},

		relatedFields() {
			if (!this.defaultGridView) return [];
			if (!this.currentGridView) return [];
			if (!this.defaultGridView.Columns) return [];
			let columns = this.defaultGridView.Columns.filter(
				(c) =>
					c.LinkField &&
					c.LinkField.Id &&
					c.LinkField.Id == this.gridViewField.LinkFieldId
			);
			let result = [];
			columns.forEach((x) => {
				let visibleColumn = this.currentGridView.Columns.find(
					(c) => c.DataFieldId === x.DataFieldId
				);
				let item = {
					gridViewField: x,
					itemKey: gridViewFieldsUtils.getFieldName(x),
					currentGridViewColumn: visibleColumn,
					currentGridViewColumnKey:
						gridViewFieldsUtils.getFieldName(visibleColumn),
				};
				result.push(item);
			});
			return result;
		},

		columnsKeys() {
			if (!this.relatedFields) return [];
			return this.relatedFields.map((x) => x.currentGridViewColumnKey);
		},

		column() {
			if (!this.currentGridView) return null;
			let visibleColumn = this.currentGridView.Columns.find(
				(x) => x.DataFieldId === this.gridViewField.DataFieldId
			);
			return visibleColumn;
		},
		columnKey() {
			if (!this.relatedFields) return null;
			let item = this.relatedFields.find(
				(x) => x.gridViewField.Id == this.gridViewField.Id
			);
			if (!item) return null;
			return item.currentGridViewColumnKey;
		},

		columnsIds() {
			if (!this.relatedFields) return [];
			return this.relatedFields
				.map((x) => x.currentGridViewColumn)
				.map((x) => x.Id);
		},

		itemKey() {
			if (!this.gridViewField) return null;
			return gridViewFieldsUtils.getFieldName(this.gridViewField);
		},
		idKey() {
			if (!this.gridViewField) return null;
			if (!this.gridViewField.LinkField) return null;
			return dataFieldUtils.getDataFieldName(
				this.gridViewField.LinkField
			);
		},
	},
	watch: {
		menuStatus(newVal) {
			if (!newVal) {
				this.search = null;
				this.linkFieldValues = [];
				return;
			}
			if (this.search === null) this.search = this.value;
			this.onSearchChanged();
		},
		item(newVal) {
			if (newVal) {
				if (newVal[this.itemKey]) {
					this.value = newVal[this.itemKey];
				} else {
					this.value = null;
				}
			}
		},
	},
	mounted() {
		if (this.item && this.item[this.itemKey]) {
			this.value = this.item[this.itemKey];
		}
	},
	methods: {
		onRowClicked(value) {
			this.onSelectItem(value);
			this.closeDialog();
		},
		onMore() {
			this.showDialog = true;
			this.menuStatus = false;
		},
		closeDialog() {
			this.showDialog = false;
			this.menuStatus = false;
		},
		onClear() {
			this.onSelectItem(null);
		},
		onSearchClear() {
			this.search = null;
			this.onSearchChanged();
		},

		onSelectItem(selectedRow) {
			let recordKey = [];
			let itemKeys = [];
			if (this.isNull) {
				recordKey.push({
					key: this.gridViewField.LinkField.FieldName,
					value: null,
				});
				itemKeys.push({ key: this.idKey, value: null });

				this.relatedFields.forEach((f) => {
					itemKeys.push({ key: f.itemKey, value: null });
				});
				this.$emit('valueChanged', itemKeys, recordKey, this.isNull);
				this.menuStatus = false;
			} else {
				this.selected = selectedRow;
				if (this.selected && this.selected[this.columnKey]) {
					this.value = this.selected[this.columnKey];
				} else {
					this.value = null;
				}
				let id = null;
				if (this.selected && this.selected.Id) {
					id = this.selected.Id;
				}
				recordKey.push({
					key: this.gridViewField.LinkField.FieldName,
					value: id,
				});
				itemKeys.push({ key: this.idKey, value: id });

				this.relatedFields.forEach((f) => {
					let val = null;
					if (
						this.selected &&
						this.selected[f.currentGridViewColumnKey]
					) {
						val = this.selected[f.currentGridViewColumnKey];
					}
					itemKeys.push({ key: f.itemKey, value: val });
				});
				this.menuStatus = false;
			}
			this.$emit('valueChanged', itemKeys, recordKey, this.isNull);
		},
		onSearchChanged() {
			let payload = {
				ViewId: this.currentGridView.Id,
				QuickFilter: this.search
					? { FieldId: this.column.Id, Value: this.search }
					: null,
				RowsPerPage: 10,
				Page: 1,
				Columns: this.columnsIds,
				IncludeCount: true,
			};
			this.loading = true;
			this.$store
				.dispatch(GridsPageEditActions.LOAD_LINK_FIELD_VALUES, payload)
				.then((resp) => {
					if (resp) {
						this.linkFieldValues = resp.Data;
					}
					this.loading = false;
				});
		},
	},
};
</script>
<style lang="scss">
.rotate {
	transform: rotate(180deg);
}
</style>
